module.exports = __webpack_public_path__ + "static/media/doorstep-selling.9eec80b3.svg";